module.exports = __webpack_public_path__ + "static/img/icon_gzh_btn_sel.976f588.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_gzh_btn_sel.png
// module id = ZONw
// module chunks = 1